import React, { useMemo } from 'react'
import style from "./index.module.scss"

// import ad1 from "assets/img/png/icon_ad_1@3x.png"
// import ad2 from "assets/img/png/icon_ad_2@3x.png"
// import ad3 from "assets/img/png/icon_ad_3@3x.png"
// import ad4 from "assets/img/png/icon_ad_4@3x.png"

import vip1 from "assets/img/png/icon_member_vip@2x.png"
import vip2 from "assets/img/png/icon_member_clean@2x.png"
import vip3 from "assets/img/png/icon_member_speed@2x.png"
import vip4 from "assets/img/png/icon_member_device@2x.png"

import chrome from "assets/img/png/btn_icon_chrome@2x.png"
import windows from "assets/img/png/btn_icon_windows@2x.png"
import tv from "assets/img/png/btn_icon_tv@2x.png"
import android from "assets/img/png/btn_icon_android@2x.png"
import mac from "assets/img/png/btn_icon_mac@2x.png"
import ios from "assets/img/png/btn_icon_ios@2x.png"

// const list1 = [
//   {
//     icon: ad1,
//     text: '三设备共享时长'
//   },
//   {
//     icon: ad2,
//     text: '可自选会员线路'
//   }
// ]
// const list2 = [
//   {
//     icon: ad3,
//     text: '手机端永无广告'
//   },
//   {
//     icon: ad4,
//     text: '不限速畅享带宽'
//   },
// ]
const list = [
  {
    icon: vip1,
    text: '可自选会员线路'
  },
  {
    icon: vip2,
    text: '手机端永无广告'
  },
  {
    icon: vip3,
    text: '不限速畅享带宽'
  },
  {
    icon: vip4,
    text: '三设备共享时长'
  }
]
const deviceList = [
  {
    icon: chrome,
    text: 'chrome',
    link: 'https://chrome.google.com/webstore/detail/%E7%A9%BF%E6%A2%ADtransocks%E5%8A%A0%E9%80%9F%E5%99%A8-%E6%B5%B7%E5%A4%96%E5%8D%8E%E4%BA%BA%E5%9B%9E%E5%9B%BD%E8%BF%BD%E5%89%A7%E5%90%AC%E6%AD%8C/ikobbjiomdcedikdmkfhlhoagpailcbh'
  },
  {
    icon: windows,
    text: 'pc',
    link: 'https://download.chuansuo.io/transocks/download/windows/3.2.6/Transocks_Win_v3.2.6_official_x64.exe'
  },
  {
    icon: tv,
    text: 'tv',
    link: 'https://download.chuansuo.io/transocks/download/tv/download/4.0.8/Transocks-tv4.0.8-official.apk'
  },
  {
    icon: android,
    text: 'android',
    link: 'https://download.chuansuo.io/transocks/download/android/3.1.7/Transocks_official_release_v450_n3.1.7.apk'
  },
  {
    icon: mac,
    text: 'mac_website',
    link: 'https://download.chuansuo.io/transocks/download/mac/3.0.9/Transocks_official_v3.0.9.dmg'
  },
  {
    icon: ios,
    text: 'ios',
    link: 'https://apps.apple.com/cn/app/id1171836473'
  },
]

// function VipExplain() {
//   return useMemo(() => (
//     <div className={style['vip-explain']}>
//       <div className={style.list}>
//         {
//           list1.map(item => (
//             <Item
//               key={item.icon}
//               {...item}
//             />
//           ))
//         }
//       </div>
//       <div className={style.list}>
//         {
//           list2.map(item => (
//             <Item
//               key={item.icon}
//               {...item}
//             />
//           ))
//         }
//       </div>
//     </div>
//   ), [])
// }
const Poster = () => {
  //点击下载链接
  const downloadLink = (link, text) => {
    if (document.body.clientWidth < 800) { return }
    if (localStorage.links) {
      window.location.href = JSON.parse(localStorage.links).url[text]
    } else {
      window.location.href = link
    }
  }

  return useMemo(() => (<div className={style.poster}>
    <div className={style.info}>
      <div className={style.left} >
        <div className={style.title}>
          海外华人回国追剧听歌炒股加速器
        </div>
        <div className={style.content}>
        一键解决中国大陆主流影音、股票、行业软件及网站访问卡顿，一键穿越，带你回家。
        </div>
        <div className={style.vip}>
          <div className={style.vipTitle}>
            VIP会员尊享特权
          </div>
          <div className={style.vipContent}>
            {
              list.map(i => <div key={i.icon} className={style.vipItems}>
                <img src={i.icon} alt="" />
                <div>{i.text}</div>
              </div>)
            }
          </div>

        </div>

      </div>
      <div className={style.right} ></div>
    </div>
    <div className={style.download}>
      {
        deviceList.map(i => <img key={i.text} onClick={() => downloadLink(i.link, i.text)} src={i.icon} alt={i.text} />)
      }
    </div>
  </div>), [])
}

// interface ItemProps {
//   icon: string
//   text: string
// }

// function Item({ icon, text }: ItemProps) {
//   return (
//     <div className={style['vip-item']}>
//       <img className={style.icon} src={icon} alt="icon" />
//       <span>{text}</span>
//     </div>
//   )
// }

export default React.memo(Poster)
